module.exports = __webpack_public_path__ + "img/Statistics.0fb7fa72.jpg";